import { AppEnum, AppEnumHelper, DateFormatHelper, OptionHelper, RecordMap, RoleHelper, USER_ROLES, UserEnums, UserRole } from "@/Shared";

import { PasswordFormValues, UserFormValues } from "../UserFormValidation";
import { UserModel } from '../UserModel';
import { PersonFormViewModel } from "@/Domains/Person/Logic/ViewModels/PersonFormViewModel";


export class UserFormViewModel extends PersonFormViewModel {
    public roleLabel! : string;
    public role! : string;

    public constructor(
        private viewEnums: UserEnums,  
        private userMap: RecordMap<UserModel>,  
        private user?: UserModel
    ) { 
        super(viewEnums.CivilityEnum, user?.person);
        this.role = this.user?.role ?? USER_ROLES.USER;
        this.roleLabel = AppEnumHelper.getLabel(this.viewEnums.UserRoleEnum, this.role);
    }

    get formValues() {
        return {
            id : super.id,
            person: super.getFormValues(),
            managerId : this.user?.managerId ?? "",
            hiredAt : DateFormatHelper.toInput(this.user?.hiredAt),
            firedAt : DateFormatHelper.toInput(this.user?.firedAt),
            username : this.user?.username ?? "",
            role : this.role
        } as UserFormValues
    }

    get passwordFormValues() {
        return {
            id : super.id,
            password : "",
            newPassword : "",
            passwordConfirmation : ""
        } as PasswordFormValues;
    }

    get roleOptions(): AppEnum[] {
        return this.viewEnums.UserRoleEnum;
    }

    get managerOptions(): AppEnum[] {
        return OptionHelper.userOptions(this.userMap.toArray());
    }

    get title() {
        return super.getTitle("Agent");
    }

    /**
     * =====================================================
     * Dropdown Options
     * =====================================================
     */
    get positionOptions(): AppEnum[] {
        return this.viewEnums.UserPositionEnum;
    }

    getHighestRole(positions : string[]) : string {
        
        let highestRole = USER_ROLES.USER;

        (positions ?? []).forEach(position => {
            const posEnum = AppEnumHelper.getByValue(this.viewEnums.UserPositionEnum, position);
            const role = posEnum?.parent?.value as UserRole;
            
            if(role && RoleHelper.isHigherThan(highestRole, role)) {
                highestRole = role;
            }
        });

        return highestRole;
    }
}